import React from 'react'
import { faEye, faFileAlt } from '@fortawesome/free-solid-svg-icons';

//Helpers
import { abrirPDF } from '../../../helpers/abrirPDF';
import { showMessage } from '../../../helpers/message';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Documentos({ pgrs, documentosPGRS, onChangeDocumentos = () => { } }) {
  const handleFileChange = (e, documento) => {
    if (!e.target.files[0].type.startsWith("application/pdf")) {
      showMessage(
        "Aviso",
        "Apenas arquivos no formato PDF é permitido. Por favor, selecione um arquivo válido.",
        "warning",
        null
      );
      return;
    }

    const FR = new FileReader();

    FR.addEventListener("load", function (evt) {
      let base64 = evt.target.result.split(",")[1];
      onChangeDocumentos({ tbFormularioPGRSDocumentos_Id: documento.id, arquivo: base64, identificacao: documento.identificacao })
    });

    FR.readAsDataURL(e.target.files[0]);
  };

  return (
    <div className="container p-2 m-2">
      {documentosPGRS.map((documento, index) => (
        <div key={index} className="card mb-3 shadow">
          <div className="row g-0 align-items-center">
            <div className="col-auto d-flex flex-column align-items-center p-3">
              <div className="d-flex align-items-center" style={{ cursor: 'pointer' }}>
                <label htmlFor={`file-upload-${index}`} className="mb-0" style={{ cursor: "pointer" }}>
                  <FontAwesomeIcon
                    icon={faFileAlt}
                    className={`${pgrs?.tbPGRSGeradorDocumentos?.some(doc => doc.tbFormularioPGRSDocumentos_Id === documento.id) ? "text-success" : "text-secondary"} mb-2`}
                    size="4x"
                  />
                </label>
                <input
                  id={`file-upload-${index}`}
                  type="file"
                  accept="application/pdf"
                  style={{ display: 'none' }}
                  onChange={(e) => handleFileChange(e, documento)}
                />
              </div>
              {pgrs?.tbPGRSGeradorDocumentos?.some(doc => doc.tbFormularioPGRSDocumentos_Id === documento.id) &&
                <button className="btn btn-primary btn-sm mt-2" onClick={() => {
                  let anexo = pgrs?.tbPGRSGeradorDocumentos?.filter(doc => doc.tbFormularioPGRSDocumentos_Id === documento.id)[0].arquivo;
                  if (anexo?.includes(".pdf"))
                    window.open(anexo, "_blank")
                  else
                    abrirPDF(anexo)
                }}>
                  <FontAwesomeIcon icon={faEye} /> Visualizar
                </button>}
            </div>
            <div className="col">
              <div className="card-body" style={{ color: "#666" }}>
                <div className="d-flex align-items-center">
                  <h3 className="mb-0">{documento.identificacao}</h3>
                  {documento.obrigatorio && (
                    <span className="badge bg-danger text-white ms-3">
                      Obrigatório
                    </span>
                  )}
                </div>
                <p>
                  <span className="fw-bold">Descrição: </span> {documento.descricao}
                </p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
